import React from "react";
import { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import axios from "axios";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import { Eye, EyeOff } from "lucide-react";
import LoadingOverlay from "react-loading-overlay-ts";
import {
  actlistData,
  joinAuction,
  actmore,
  setisfirsttime,
} from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FirebaseContext } from "../../FirebaseContext";
import styled from "styled-components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { RxCross2 } from "react-icons/rx";
// import {
//   Drawer,
//   IconButton,
//   ListItem,
//   ListItemText,
//   List,
//   Popover,
// } from "@mui/material";
import { MdClose } from "react-icons/md";
import { useSpecState } from "./SpecContext.jsx";
import { FaAngleUp } from "react-icons/fa6";
import { FaAngleDown } from "react-icons/fa6";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const sp1opt = [
  "All Rounder",
  "Batting All Rounder",
  "Bowling All Rounder",
  "All Rounder Wicketkeeper",
  "Batsman",
  "Bowler",
  "Wicket Keeper",
  "Batter",
  "Other",
];
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }], // font size
    ["bold", "italic", "underline"], // formatting
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    // ["clean"], // remove formatting
    [{ color: [] }],
  ],
};
const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "align",
  "color",
];

const sp2opt = [
  "Right Hand",
  "Left Hand",
  "Right Hand Batsman",
  "Left Hand Batsman",
  "Right Hand Opener",
  "Left Hand Opener",
  "Right Hand Middle Order",
  "Left Hand Middle Order",
];

const sp3opt = [
  "Right Arm Fast",
  "Right Arm Medium",
  "Left Arm Fast",
  "Left Arm Medium",
  "Off-Break",
  "Leg-Break",
  "Left Arm Orthodox",
  "Left Arm Chinaman",
];

// Add additional styles
const additionalStyles = `
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
}

.reset-options-btn {
    background: none;
    border: none;
    color: #2196F3;
    cursor: pointer;
    font-size: 18px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
}

.reset-options-btn:hover {
    transform: rotate(30deg);
    color: #0b7dda;
}

.defaultopt-div {
    display: flex;
    align-items: center;
}

.checkbox-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.checkbox-container input {
    margin-right: 8px;
}

.checkbox-label {
    font-size: 14px;
    color: #4a5568;
}

.field-inputs {
    display: flex;
    gap: 1rem;
    flex: 1;
}

.customize_css{
    input{
        min-height:20px;
    }

}

.label-input,
.placeholder-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 1.3rem;
    color: #1e293b;
}

.label-input::placeholder,
.placeholder-input::placeholder {
    color: #94a3b8;
    font-size: 1.3rem;
}

.control-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.checkbox-label-new {
    margin: 0 8px;
    font-size: 1.3rem;
    display:flex;
    // align-items:center;
}

.checkbox-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin-right: 8px;
}

.field-type-selector {
    margin-top: 0.75rem;
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

.type-select {
    flex: 1;
}

.form-actions {
    margin-top: 2rem;
    text-align: center;
    position: sticky;
    bottom: 1rem;
    background: white;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 -4px 6px rgba(0,0,0,0.05);
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
}

.options-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
}

.field-inputs {
    display: flex;
    gap: 1rem;
    flex: 1;
}

.custom-label-input,
.custom-placeholder-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 1.3rem;
    color: #1e293b;
}

.custom-label-input::placeholder,
.custom-placeholder-input::placeholder {
    color: #94a3b8;
    font-size: 1.3rem;
}

.field-type-selector {
    margin-top: 0.75rem;
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

.type-select {
    flex: 1;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 1.3rem;
    color: #1e293b;
}

.field-inputs {
    display: flex;
    gap: 1rem;
    flex: 1;
    margin-right: 1rem;
}

.field-card {
    position: relative;
    overflow: hidden;
}

.field-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: #3b82f6;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.field-card:hover::before {
    opacity: 1;
}

/* QR Guide Styles */
.qr-guide-container {
    background-color: #f8fafc;
    border-radius: 8px;
    margin: 15px 0 25px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.qr-guide-header {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f1f5f9;
    cursor: pointer;
    transition: background-color 0.2s;
    border-bottom: 1px solid #e2e8f0;
}

.qr-guide-header:hover {
    background-color: #e2e8f0;
}

.qr-guide-title {
    font-size: 16px;
    font-weight: 500;
    color: #334155;
    display: flex;
    align-items: center;
}

.qr-guide-toggle {
    color: #64748b;
}

.qr-guide-content {
    padding: 15px 20px;
    font-size: 14px;
    color: #475569;
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.qr-guide-steps ol {
    padding-left: 25px;
}

.qr-guide-steps li {
    margin-bottom: 15px;
    line-height: 1.5;
}

.qr-guide-tips ul {
    padding-left: 25px;
    list-style-type: disc;
}

.qr-guide-tips li {
    margin-bottom: 8px;
}

.qr-example-images {
    display: flex;
    gap: 20px;
    margin-top: 10px;
}

.qr-example {
    text-align: center;
    width: 100px;
}

.qr-example .example-img {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 8px;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 24px;
}

.qr-example span {
    font-size: 12px;
}

.qr-example.good .example-img {
    background-color: #dcfce7;
    color: #16a34a;
}

.qr-example.bad .example-img {
    background-color: #fee2e2;
    color: #dc2626;
}

.qr-guide-steps h4, .qr-guide-tips h4 {
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 600;
    color: #334155;
}

/* QR Scan Simulation Styles */
.preview-container {
    position: relative;
}

.scanning-animation {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { opacity: 0.7; }
    50% { opacity: 1; }
    100% { opacity: 0.7; }
}

.scan-simulation-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
}

.scan-simulation-overlay.scanning {
    background-color: rgba(0, 0, 0, 0.1);
}

.scan-simulation-overlay.success {
    background-color: rgba(220, 252, 231, 0.7);
    border: 2px solid #16a34a;
}

.scan-simulation-overlay.warning {
    background-color: rgba(254, 226, 226, 0.7);
    border: 2px solid #dc2626;
}

.scanning-line {
    width: 100%;
    height: 2px;
    background-color: #3b82f6;
    position: absolute;
    animation: scanLine 1.5s linear infinite;
}

@keyframes scanLine {
    0% { top: 0; }
    100% { top: 100%; }
}

.scanning-text, .scan-result-text {
    font-size: 12px;
    font-weight: 500;
    margin-top: 8px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 4px 8px;
    border-radius: 4px;
}

.scan-result-icon {
    font-size: 32px;
    background-color: white;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.scan-simulation-overlay.success .scan-result-icon {
    color: #16a34a;
}

.scan-simulation-overlay.warning .scan-result-icon {
    color: #dc2626;
}

/* QR Content Layout */
.qr-content-wrapper {
    display: flex;
    gap: 30px;
    align-items: flex-start;
    margin-top: 15px;
}

.qr-main-content {
    flex: 2.5;
}

.qr-side-guide {
    flex: 1.5;
    position: sticky;
    top: 20px;
}

.qr-upload-btn-container {
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px dashed #e2e8f0;
}

.qr-form-header {
    margin-bottom: 1.5rem;
    text-align: left;
}

.qr-form-header h4 {
    color: #334155;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
}

/* Make QR layout responsive on smaller screens */
@media (max-width: 768px) {
    .qr-content-wrapper {
        flex-direction: column;
    }
    
    .qr-side-guide {
        position: static;
        width: 100%;
        margin-top: 30px;
    }
}

.qr-mini-guide {
    background-color: #f0f9ff;
    border-radius: 8px;
    padding: 20px;
    border-left: 4px solid #3b82f6;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.qr-mini-guide h4 {
    margin-top: 0;
    margin-bottom: 15px;
    color: #334155;
    font-size: 16px;
    font-weight: 600;
}

.qr-mini-guide ul {
    margin: 0;
    padding-left: 25px;
    list-style-type: disc;
}

.qr-mini-guide li {
    font-size: 14px;
    margin-bottom: 12px;
    color: #475569;
    line-height: 1.4;
    padding-left: 5px;
}

.whatsapp-link-preview {
    margin-top: 1rem;
    padding: 1rem;
    background-color: #f0f9ff;
    border-radius: 8px;
    border-left: 4px solid #3b82f6;
    font-size: 1.2rem;
    word-break: break-all;
}
  
.whatsapp-error {
    color: #e53e3e;
    font-size: 0.875rem;
    margin-top: 0.5rem;
}
  
.whatsapp-info {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    padding: 1rem;
    background-color: #f7fee7;
    border-radius: 8px;
    border-left: 4px solid #84cc16;
}
  
.whatsapp-info-icon {
    margin-right: 1rem;
    font-size: 1.5rem;
    color: #84cc16;
}
  
.whatsapp-info-text {
    color: #3f6212;
    font-size: 1.3rem;
}
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = additionalStyles;
document.head.appendChild(styleSheet);

// Add new styled components
const DescriptionContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  h3 {
    margin: 0 0 1rem 0;
    color: #1e293b;
    font-size: 1.4rem;
    font-weight: 500;
  }

  .description-helper {
    color: #64748b;
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
  }
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1.3rem;
  line-height: 1.5;
  color: #1e293b;
  resize: vertical;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

const PageContainer = styled.div`
  min-height: 100vh;
  background: #f3f4f6;
  padding: 2rem;
`;

const FormContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const StyledTabs = styled(Tabs)`
  background: #f8fafc;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  padding: 2rem;

  .react-tabs__tab-list {
    border-bottom: 2px solid #eef2f7;
    margin-bottom: 2rem;
  }

  .react-tabs__tab {
    padding: 1rem 2rem;
    font-weight: 500;
    color: #64748b;

    &--selected {
      color: #3b82f6;
      border-color: #3b82f6;
    }
  }
`;

const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.2s ease;
  height: fit-content;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    // transform: translateY(-3px);
    border-color: #d1d5db;
  }

  /* Add subtle highlight on the top border */
  border: 1px solid #3b82f6;
  .field-actions {
    display: flex;
    align-items: center;
  }
`;

const FieldHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 1rem;

  .field-inputs {
    display: flex;
    gap: 1rem;
    flex: 1;
  }
`;

const FieldLabel = styled.div`
  font-weight: 500;
  color: #1e293b;
  font-size: 1.4rem;
`;

const ControlsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 1rem;

  .checkbox-container {
    grid-column: 1 / -1;
    margin-top: 0.5rem;
  }
`;

const CustomFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const ActionButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &.primary {
    background: #3b82f6;
    color: white;
    border: none;

    &:hover {
      background: #2563eb;
    }
  }

  &.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;

    &:hover {
      background: #f8fafc;
    }
  }
`;

// const removeItem = (item) => {
//     //console.log('efef');
//   }

const FormField = ({
  label,
  field,
  onChange,
  state,
  setState,
  updateState,
  addItem,
  removeOption,
  setfield,
}) => (
  <FieldCard>
    <FieldHeader>
      <FieldLabel>{label}</FieldLabel>
      <div className="field-actions">
        {["Specification 1", "Specification 2", "Specification 3"].includes(
          label
        ) ? (
          <div className="two-switch-wrapper">
            <span className="toggle-label text">Text</span>

            <label className="switch">
              <input
                type="checkbox"
                checked={field.t === "1"}
                onChange={(e) =>
                  onChange(field.k, "t", e.target.checked ? "1" : "0")
                }
              />
              <span className="slider" />
            </label>

            <span className="toggle-label right">Options</span>

            <button
              type="button"
              onClick={() =>
                onChange(field.k, "s", field.s === "1" ? "0" : "1")
              }
              className="flex items-start justify-start p-4 text-blue-500 hover:text-blue-700 focus:outline-none"
              style={{
                border: "none",
                backgroundColor: "white",
                color: "#3b82f6",
              }}
              aria-label={field.s === "1" ? "Hide field" : "Show field"}
            >
              {field.s === "1" ? (
                <Eye className="w-5 h-5" />
              ) : (
                <EyeOff className="w-5 h-5" />
              )}
            </button>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => onChange(field.k, "s", field.s === "1" ? "0" : "1")}
            className="flex items-start justify-start p-4 text-blue-500 hover:text-blue-700 focus:outline-none"
            style={{
              border: "none",
              backgroundColor: "white",
              color: "#3b82f6",
            }}
            aria-label={field.s === "1" ? "Hide field" : "Show field"}
          >
            {field.s === "1" ? (
              <Eye className="w-5 h-5" />
            ) : (
              <EyeOff className="w-5 h-5" />
            )}
          </button>
        )}
      </div>
    </FieldHeader>

    <ControlsGrid>
      <div className="control-group">
        <input
          type="text"
          value={field.l}
          onChange={(e) => onChange(field.k, "l", e.target.value)}
          placeholder="Custom label"
          className="label-input"
        />
      </div>

      <div className="control-group spec-field">
        {/* If switch is ON → option input UI */}
        {field.t === "1" ? (
          <>
            {/* OPTION MODE UI */}

            {label === "Specification 1" && (
              <div className="drawer-div">
                <input
                  type="text"
                  value={state.newItem}
                  placeholder="Option"
                  onChange={(e) => updateState("newItem", e.target.value)}
                />
                <button
                  className="draweraddbtn"
                  onClick={() => {
                    const currentOptions = state.sp1Opt.join(",");
                    const newOptions = currentOptions
                      ? `${currentOptions},${state.newItem}`
                      : state.newItem;

                    setfield((prev) => ({
                      ...prev,
                      ["sp1"]: {
                        ...prev["sp1"],
                        ["o"]: newOptions,
                      },
                    }));

                    addItem("openSpec1", "sp1");
                  }}
                >
                  Add
                </button>
              </div>
            )}

            {label === "Specification 2" && (
              <div className="drawer-div">
                <input
                  type="text"
                  value={state.newItem2}
                  placeholder="Option"
                  onChange={(e) => updateState("newItem2", e.target.value)}
                />
                <button
                  className="draweraddbtn"
                  onClick={() => {
                    const currentOptions = state.sp2Opt.join(",");
                    const newOptions = currentOptions
                      ? `${currentOptions},${state.newItem2}`
                      : state.newItem2;

                    setfield((prev) => ({
                      ...prev,
                      ["sp2"]: {
                        ...prev["sp2"],
                        ["o"]: newOptions,
                      },
                    }));

                    addItem("openSpec2", "sp2");
                  }}
                >
                  Add
                </button>
              </div>
            )}

            {label === "Specification 3" && (
              <div className="drawer-div">
                <input
                  type="text"
                  value={state.newItem3}
                  placeholder="Option"
                  onChange={(e) => updateState("newItem3", e.target.value)}
                />
                <button
                  className="draweraddbtn"
                  onClick={() => {
                    const currentOptions = state.sp3Opt.join(",");
                    const newOptions = currentOptions
                      ? `${currentOptions},${state.newItem3}`
                      : state.newItem3;

                    setfield((prev) => ({
                      ...prev,
                      ["sp3"]: {
                        ...prev["sp3"],
                        ["o"]: newOptions,
                      },
                    }));

                    addItem("openSpec3", "sp3");
                  }}
                >
                  Add
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <input
              type="text"
              value={field.p || ""}
              onChange={(e) => onChange(field.k, "p", e.target.value)}
              placeholder="Text value"
              className="placeholder-input"
            />
          </>
        )}
      </div>

      <div className="control-group checkbox-container required-container">
        <label className="checkbox-label checkbox-label-new">
          <input
            type="checkbox"
            checked={field.r === "1"}
            onChange={(e) =>
              onChange(field.k, "r", e.target.checked ? "1" : "0")
            }
          />
          <span>Required</span>
        </label>
      </div>
      {field.t === "1" &&
        (label === "Specification 1" ||
          label === "Specification 2" ||
          label === "Specification 3") && (
          <div className="control-group draweropenbtn-div">
            {label === "Specification 1" && (
              <>
                <div className="defaultopt-div">
                  <button
                    className="opendrawer-div"
                    onClick={() => {
                      // Close other drawers when opening this one
                      if (!state.openSpec1) {
                        updateState("openSpec2", false);
                        updateState("openSpec3", false);
                      }
                      updateState("openSpec1", !state.openSpec1);
                    }}
                  >
                    Default options
                    <div className="arrowbtn-div">
                      {state.openSpec1 == false ? (
                        <FaAngleDown />
                      ) : (
                        <FaAngleUp />
                      )}
                    </div>
                  </button>
                  <button
                    className="reset-options-btn"
                    title="Reset to default options"
                    onClick={() => {
                      // Reset to default sp1opt
                      updateState("sp1Opt", sp1opt);

                      // Update the field options
                      setfield((prevOptions) => ({
                        ...prevOptions,
                        ["sp1"]: {
                          ...prevOptions["sp1"],
                          ["o"]: "",
                        },
                      }));
                    }}
                  >
                    <AiIcons.AiOutlineReload />
                  </button>
                </div>

                {state.openSpec1 && (
                  <div
                    className="drawerpage"
                    open={state.openSpec1}
                    onClose={() => updateState("openSpec1", false)}
                  >
                    <ul className="">
                      {(state?.sp1Opt || []).map((ele) => (
                        <li key={ele} className="drawerlist">
                          {ele}{" "}
                          {
                            <div
                              onClick={() => {
                                // Get all options except the clicked one
                                const remainingOptions = state.sp1Opt.filter(
                                  (option) => option !== ele
                                );
                                // Join the remaining options with commas
                                const optionsString =
                                  remainingOptions.join(",");

                                setfield((prevlOptions) => ({
                                  ...prevlOptions,
                                  ["sp1"]: {
                                    ...prevlOptions["sp1"],
                                    ["o"]: optionsString,
                                  },
                                }));

                                removeOption(field, "openSpec1", ele);
                              }}
                            >
                              <MdClose />
                            </div>
                          }
                        </li>
                      ))}
                    </ul>

                    {/* <button onClick={() => updateState("openSpec1", false)}>
                    Close
                  </button> */}
                  </div>
                )}
              </>
            )}

            {label === "Specification 2" && (
              <>
                <div className="defaultopt-div">
                  <button
                    className="opendrawer-div"
                    onClick={() => {
                      // Close other drawers when opening this one
                      if (!state.openSpec2) {
                        updateState("openSpec1", false);
                        updateState("openSpec3", false);
                      }
                      updateState("openSpec2", !state.openSpec2);
                    }}
                  >
                    Default options
                    <div className="arrowbtn-div">
                      {state.openSpec2 == false ? (
                        <FaAngleDown />
                      ) : (
                        <FaAngleUp />
                      )}
                    </div>
                  </button>
                  <button
                    className="reset-options-btn"
                    title="Reset to default options"
                    onClick={() => {
                      // Reset to default sp2opt
                      updateState("sp2Opt", sp2opt);

                      // Update the field options
                      setfield((prevOptions) => ({
                        ...prevOptions,
                        ["sp2"]: {
                          ...prevOptions["sp2"],
                          ["o"]: "",
                        },
                      }));
                    }}
                  >
                    <AiIcons.AiOutlineReload />
                  </button>
                </div>

                {state.openSpec2 && (
                  <div
                    className="drawerpage"
                    open={state.openSpec2}
                    onClose={() => updateState("openSpec2", false)}
                  >
                    <ul className="">
                      {(state?.sp2Opt || []).map((ele) => (
                        <li key={ele} className="drawerlist">
                          {ele}
                          {
                            <div
                              onClick={() => {
                                // Get all options except the clicked one
                                const remainingOptions = state.sp2Opt.filter(
                                  (option) => option !== ele
                                );
                                // Join the remaining options with commas
                                const optionsString =
                                  remainingOptions.join(",");

                                setfield((prevlOptions) => ({
                                  ...prevlOptions,
                                  ["sp2"]: {
                                    ...prevlOptions["sp2"],
                                    ["o"]: optionsString,
                                  },
                                }));

                                removeOption(field, "openSpec2", ele);
                              }}
                            >
                              <MdClose />
                            </div>
                          }
                        </li>
                      ))}
                    </ul>

                    {/* <button onClick={() => updateState("openSpec1", false)}>
                    Close
                  </button> */}
                  </div>
                )}
              </>
            )}

            {label === "Specification 3" && (
              <>
                <div className="defaultopt-div">
                  <button
                    className="opendrawer-div"
                    onClick={() => {
                      // Close other drawers when opening this one
                      if (!state.openSpec3) {
                        updateState("openSpec1", false);
                        updateState("openSpec2", false);
                      }
                      updateState("openSpec3", !state.openSpec3);
                    }}
                  >
                    Default options
                    <div className="arrowbtn-div">
                      {state.openSpec3 == false ? (
                        <FaAngleDown />
                      ) : (
                        <FaAngleUp />
                      )}
                    </div>
                  </button>
                  <button
                    className="reset-options-btn"
                    title="Reset to default options"
                    onClick={() => {
                      // Reset to default sp3opt
                      updateState("sp3Opt", sp3opt);

                      // Update the field options
                      setfield((prevOptions) => ({
                        ...prevOptions,
                        ["sp3"]: {
                          ...prevOptions["sp3"],
                          ["o"]: "",
                        },
                      }));
                    }}
                  >
                    <AiIcons.AiOutlineReload />
                  </button>
                </div>

                {state.openSpec3 && (
                  <div
                    className="drawerpage"
                    open={state.openSpec3}
                    onClose={() => updateState("openSpec3", false)}
                  >
                    <ul className="">
                      {(state?.sp3Opt || []).map((ele) => (
                        <li key={ele} className="drawerlist">
                          {ele}{" "}
                          {
                            <div
                              onClick={() => {
                                // Get all options except the clicked one
                                const remainingOptions = state.sp3Opt.filter(
                                  (option) => option !== ele
                                );
                                // Join the remaining options with commas
                                const optionsString =
                                  remainingOptions.join(",");

                                setfield((prevlOptions) => ({
                                  ...prevlOptions,
                                  ["sp3"]: {
                                    ...prevlOptions["sp3"],
                                    ["o"]: optionsString,
                                  },
                                }));

                                removeOption(field, "openSpec3", ele);
                              }}
                            >
                              <MdClose />
                            </div>
                          }
                        </li>
                      ))}
                    </ul>

                    {/* <button onClick={() => updateState("openSpec1", false)}>
                    Close
                  </button> */}
                  </div>
                )}
              </>
            )}
          </div>
        )}
    </ControlsGrid>
  </FieldCard>
);

const CustomField = ({ field, index, onUpdate, onDelete }) => (
  <FieldCard>
    <FieldHeader>
      <div className="field-inputs">
        <input
          type="text"
          value={field.l}
          onChange={(e) => onUpdate(index, "l", e.target.value)}
          placeholder="Field Label"
          className="custom-label-input"
        />
        <input
          type="text"
          value={field.p || ""}
          onChange={(e) => onUpdate(index, "p", e.target.value)}
          placeholder="Field Placeholder"
          className="custom-placeholder-input"
        />
      </div>
      <ActionButton className="secondary" onClick={() => onDelete(index)} title="Remove field">
        <span aria-hidden="true" style={{ fontSize: "1.25em" }}>×</span>
      </ActionButton>
    </FieldHeader>

    <ControlsGrid>
      <div className="control-group">
        <span>Show Field</span>
        <label className="switch">
          <input
            type="checkbox"
            checked={field.s === "1"}
            onChange={(e) => onUpdate(index, "s", e.target.checked ? "1" : "0")}
          />
          <span className="slider" />
        </label>
      </div>
      <div className="control-group">
        <span>Required</span>

        <label className="switch">
          <input
            type="checkbox"
            checked={field.r === "1"}
            onChange={(e) => onUpdate(index, "r", e.target.checked ? "1" : "0")}
          />
          <span className="slider" />
        </label>
      </div>
    </ControlsGrid>

    <div className="field-type-selector">
      <select
        value={field.t || "0"}
        onChange={(e) => onUpdate(index, "t", e.target.value)}
        className="type-select"
      >
        <option value="0">Text Input</option>
        <option value="1">Number Input</option>
        <option value="2">Dropdown Options</option>
        <option value="3">Check Box</option>
        <option value="4">File Upload</option>
        <option value="5">Date</option>
      </select>

      {(field.t === "2" || field.t === "3") && (
        <ActionButton
          className="secondary"
          onClick={() => onUpdate(index, "showOptions", true)}
        >
          Configure Options
        </ActionButton>
      )}
      {field.t === "3" && field.options && (
        <div className="checkbox-options">
          {field.options.map((opt, i) => (
            <label key={i} className="checkbox-option">
              <input
                type="checkbox"
                checked={(field.selectedOptions || []).includes(opt)}
                onChange={() => {
                  let newSelected = [...(field.selectedOptions || [])];
                  if (newSelected.includes(opt)) {
                    newSelected = newSelected.filter(o => o !== opt);
                  } else {
                    newSelected.push(opt);
                  }
                  onUpdate(index, "selectedOptions", newSelected);
                }}
              />
              {opt}
            </label>
          ))}
        </div>
      )}
    </div>
  </FieldCard>
);

// Add Modal styled component
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h3 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.4rem;
    color: #1e293b;
  }

  .modal-description {
    color: #64748b;
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }

  .options-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }
`;

// Add Modal component
const Modal = ({ onClose, children }) => (
  <ModalOverlay onClick={onClose}>
    <ModalContent onClick={(e) => e.stopPropagation()}>{children}</ModalContent>
  </ModalOverlay>
);

// Add new styled component for QR upload section
const QRUploadContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2.5rem;
  text-align: center;
  
  margin: 0 auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

  h3 {
    margin: 0 0 1rem 0;
    color: #1e293b;
    font-size: 1.4rem;
    font-weight: 500;
  }

  .preview-container {
    margin: 1.5rem 0;
    display: flex;
    justify-content: center;
  }

  .upload-instructions {
    color: #64748b;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    text-align: left;
  }

  .header-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
  }

  .payment-options {
    display: flex;
    gap: 1.5rem;
    align-items: center;
  }

  .payment-option {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1.25rem;
    background-color: #f8fafc;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    min-width: 120px;
    justify-content: center;
  }

  .payment-option:hover {
    border-color: #3b82f6;
    background-color: #eff6ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
  }

  .payment-option input[type="radio"] {
    width: 20px;
    height: 20px;
    accent-color: #3b82f6;
    cursor: pointer;
  }

  .payment-option label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #374151;
    cursor: pointer;
    margin: 0;
    white-space: nowrap;
  }

  .payment-option input[type="radio"]:checked + label {
    color: #3b82f6;
  }

  .payment-option input[type="radio"]:checked {
    border-color: #3b82f6;
  }

  .bank-content-wrapper {
    width: 100%;
    margin: 0;
    padding: 0;
    background: transparent;
    box-shadow: none;
  }

  .bank-main-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .bank-main-content .qr-form-header {
    width: 100%;
    margin-bottom: 2rem;
    text-align: left;
  }

  .bank-main-content .qr-form-header h4 {
    margin: 0 0 1.5rem 0;
    color: #1e293b;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: left;
    border-bottom: 2px solid #3b82f6;
    padding-bottom: 0.75rem;
  }

  .bank-main-content .QRFormContainer {
    width: 100%;
    max-width: none;
  }

  .bank-main-content .QRFormField {
    margin-bottom: 1.5rem;
    text-align: left;
  }

  .bank-main-content .QRInputLabel {
    font-size: 1.1rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.75rem;
    display: block;
  }

  .bank-main-content .QRInput {
    width: 100%;
    padding: 1rem 1.25rem;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 1.1rem;
    transition: all 0.2s ease-in-out;
    background-color: #f9fafb;
    box-sizing: border-box;
  }

  .bank-main-content .QRInput:focus {
    outline: none;
    border-color: #3b82f6;
    background-color: white;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .bank-main-content .QRInput:hover {
    border-color: #d1d5db;
    background-color: white;
  }
`;

// Add styled components for QR section
const QRHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 1.2rem;
`;

const QRToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const QRToggleLabel = styled.span`
  font-size: 14px;
  color: #64748b;
`;

const QRContentContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  margin-bottom: 2rem;
`;

const QRPreviewWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  display: inline-block;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);

  img {
    max-width: 220px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1.2rem;
    display: block;
    background-color: white;
  }

  img.scanning-animation {
    animation: pulse 1.5s infinite;
  }
`;

const QRFormContainer = styled.div`
  flex: 1;
  margin-top: 0.5rem;
`;

const QRFormField = styled.div`
  margin-bottom: 1.2rem;
  text-align: left;
`;

const QRInputLabel = styled.label`
  font-size: 15px;
  display: block;
  margin-bottom: 0.6rem;
  font-weight: 500;
  color: #334155;
`;

const QRInput = styled.input`
  width: 100%;
  padding: 0.7rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`;

const QRButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const RemoveButton = styled(ActionButton)`
  && {
    background-color: #fee2e2;
    color: #dc2626;
    border: 1px solid #fecaca;
    transition: all 0.2s ease-in-out;

    &:hover {
      background-color: #ef4444;
      color: #ffffff;
      border-color: #dc2626;
    }
  }
`;

const WhatsAppLinkInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &.error {
    border-color: #e53e3e;
    background-color: #fff5f5;
  }
`;

const WhatsAppSwitch = styled.div`
  display: flex;
  align-items: center;
  background-color: #f3f4f6;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid #3b82f6;

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    cursor: pointer;
  }

  span {
    font-size: 1.3rem;
    color: #4a5568;
    font-weight: 500;
  }
`;

// Add new styled component for WhatsApp section
const WhatsAppContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: left;
  max-width: 800px;
  margin: 0 auto;

  h3 {
    margin: 0 0 1rem 0;
    color: #1e293b;
    font-size: 1.4rem;
    font-weight: 500;
  }

  .whatsapp-instructions {
    color: #64748b;
    font-size: 1.4rem;
    margin-bottom: 1.5rem;
  }

  .whatsapp-link-container {
    margin-top: 1.5rem;
  }

  .whatsapp-link-preview {
    margin-top: 1rem;
    padding: 1rem;
    background-color: #f0f9ff;
    border-radius: 8px;
    border-left: 4px solid #3b82f6;
    font-size: 1.2rem;
    word-break: break-all;
  }

  .whatsapp-error {
    color: #e53e3e;
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }

  .whatsapp-info {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    padding: 1rem;
    background-color: #f7fee7;
    border-radius: 8px;
    border-left: 4px solid #84cc16;
  }

  .whatsapp-info-icon {
    margin-right: 1rem;
    font-size: 1.5rem;
    color: #84cc16;
  }

  .whatsapp-info-text {
    color: #3f6212;
    font-size: 1.3rem;
    margin-left: 1.5rem;
  }
`;

// Add new styled component for Helpline section
const HelplineContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 8px 25px -8px rgba(0, 0, 0, 0.15),
    0 4px 10px -2px rgba(0, 0, 0, 0.1);

  h3 {
    margin: 0 0 2rem 0;
    color: #1e293b;
    font-size: 1.6rem;
    font-weight: 700;
    border-bottom: 3px solid #3b82f6;
    padding-bottom: 0.75rem;
  }

  .helpline-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2.5rem;
    margin-top: 1.5rem;
  }

  .helpline-field {
    display: flex;
    flex-direction: column;
  }

  .helpline-field label {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
  }

  .helpline-field label::before {
    content: "📞";
    margin-right: 1rem;
    font-size: 1.6rem;
  }

  .helpline-field:nth-child(1) label::before {
    content: "👤";
  }
  
  /* For additional entries - name fields get user icon */
  .helpline-field label[for*="helplineName"]::before {
    content: "👤";
  }
  
  /* For mobile fields - ensure they get phone icon */
  .helpline-field label[for*="helplineMobile"]::before {
    content: "📞";
  }

  .helpline-field label[for="formSubmittingText"]::before,
  .helpline-field label[for="termsAndConditions"]::before {
    content: none;
    display: none;
  }

  .helpline-input {
    padding: 1.25rem 1.5rem;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 1.4rem;
    transition: all 0.2s ease-in-out;
    background-color: #f9fafb;
    min-height: 60px;
  }

  .helpline-input:focus {
    outline: none;
    border-color: #3b82f6;
    background-color: white;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .helpline-input::placeholder {
    color: #9ca3af;
    font-style: italic;
  }

  .helpline-input:hover {
    border-color: #d1d5db;
    background-color: white;
  }

  /* Helpline editor full width - span grid and make Quill 100% */
  .helpline-editor-wrap {
    grid-column: 1 / -1;
    max-width: 100%;
  }
  .helpline-editor-wrap .quill-wrapper,
  .helpline-editor-wrap .quill-wrapper .ql-container,
  .helpline-editor-wrap .quill-wrapper .ql-editor {
    width: 100% !important;
    max-width: 100%;
  }
  .helpline-editor-wrap .quill-wrapper .ql-toolbar.ql-snow {
    width: 100%;
  }

  .form-submitting-row {
    grid-column: 1 / -1;
    width: 100%;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: flex-end;
    gap: 1.5rem;
  }
  .form-submitting-row .terms-checkbox-wrap {
    display: inline-flex !important;
    flex-direction: row !important;
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .form-submitting-text-wrap {
    width: 50%;
    min-width: 280px;
    max-width: 100%;
  }

  @media (max-width: 1024px) {
    .form-submitting-text-wrap {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .helpline-fields {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    .form-submitting-text-wrap {
      width: 100%;
      min-width: unset;
    }

    padding: 1.5rem;
  }
`;

const Extra = styled.div`
  background: white;
  border-radius: 13px;
  padding: 2.5rem;
  text-align: left;
  max-width: 1020px;
  margin: 0 auto;
  box-shadow: 0 8px 25px -8px rgba(0, 0, 0, 0.15),
    0 4px 10px -2px rgba(0, 0, 0, 0.1);

  h3 {
    margin: 0 0 2rem 0;
    color: #1e293b;
    font-size: 1.6rem;
    font-weight: 700;
    border-bottom: 3px solid #3b82f6;
    padding-bottom: 0.75rem;
  }
`;

function JoinauctionCode(match) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [joindata, setjoindata] = useState([]);
  const [isActive, setActive] = useState(false);
  const getpageData = useSelector((state) => state.setactlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  const [isDisabled, setDisabled] = useState(false);
  const refresh = useSelector((state) => state.setRefresh);
  const history = useHistory({ forceRefresh: true });
  const [cid, setCid] = useState(loginuser["cid"]);
  const [customcount, setcustomcount] = useState(0);
  const [cuss, setcuss] = useState("0");
  const [cusreq, setcusreq] = useState("0");
  const [cusl, setcusl] = useState("");
  const [cuslist, setcuslist] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [isoptpopup, setisoptpopup] = useState(null);
  const [optval, setoptval] = useState("");
  const [description, setDescription] = useState("");
  const [qrImage, setQrImage] = useState(null);
  const [qrPreview, setQrPreview] = useState(null);
  const [qrName, setQrName] = useState("");
  const [qrUpiId, setQrUpiId] = useState("");
  const [qrFeesEntries, setQrFeesEntries] = useState([{ label: "Registration Fees", value: "" }]);
  const [payButtonUpiId, setPayButtonUpiId] = useState("");
  const [utrField, setUtrField] = useState({ s: "0", r: "0", l: "UTR No.", p: "", t: "1" });
  const [showQR, setShowQR] = useState(false);
  const [whatsappLink, setWhatsappLink] = useState("");
  const [helplineName, setHelplineName] = useState("");
  const [helplineMobile, setHelplineMobile] = useState("");
  const [originalHelplineMobile, setOriginalHelplineMobile] = useState(""); // Track original mobile from API
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  // Multiple helpline entries
  const [helplineEntries, setHelplineEntries] = useState([]);
  const [otpInputs, setOtpInputs] = useState({}); // Store OTP for each entry
  const [sendingOtpFor, setSendingOtpFor] = useState(null); // Track which entry is sending OTP
  const [verifyingOtpFor, setVerifyingOtpFor] = useState(null); // Track which entry is verifying OTP
  const [paymentMethod, setPaymentMethod] = useState("upi");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [bankAccountName, setBankAccountName] = useState("");
  const [bankIfscCode, setBankIfscCode] = useState("");
  const [qrScanSimulation, setQrScanSimulation] = useState(null);
  const [removeAuctionDate, setRemoveAuctionDate] = useState(false);
  const [helplineDescription, setHelplineDescription] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [termsAndConditionsContent, setTermsAndConditionsContent] = useState("");
  const [formSubmittingText, setFormSubmittingText] = useState("");
  const aid = localStorage.getItem("auction_id");
  const admin_id = localStorage.getItem("admin_id");
  const auctionId = localStorage.getItem("auction_id");
  const [paymentDescription, setPaymentDescription] = useState("");
  const [activeTab, setActiveTab] = useState("detail1");

  const { state, setState, updateState, addItem, removeOption } =
    useSpecState();

  useEffect(() => {
    //console.log("state");
    //console.log(state);
  }, [state]);

  // Define all fields including mobile
  const allFields = [
    "age",
    "fname",
    "cat",
    "detail",
    "tname",
    "tno",
    "tshirt",
    "trouser",
    "icon",
    "sp1",
    "sp2",
    "sp3",
    "receipt",
    "mobile",
  ];

  // Filter out 'mobile' if admin is not logged in
  const ls = admin_id
    ? allFields
    : allFields.filter((field) => field !== "mobile");
  const defaultLabels = {
    age: "Age",
    fname: "Father's Name",
    cat: "Category",
    detail: "Detail",
    tname: "Jersey Name",
    tno: "Jersey Number",
    tshirt: "T-shirt Size",
    trouser: "Trouser",
    icon: "Icon",
    sp1: "Specification 1",
    sp2: "Specification 2",
    sp3: "Specification 3",
    receipt: "Receipt",
    mobile: "Mobile",
  };

  const initiallOptions = Object.fromEntries(
    ls.map((l, index) => [
      l,
      {
        s: l == "receipt" ? "0" : "1",
        r: l == "mobile" ? "1" : "0",
        l: defaultLabels[l] || l,
        p: "",
        k: index + 1,
        o: "",
        t: "",
      },
    ])
  );
  const [field, setfield] = useState(initiallOptions);
  const [customfield, setcustomfield] = useState([]);

  // const [spopt, setspopt] = useState("");
  useEffect(() => {
    //console.log("default field");
    //console.log(field);
  }, [field]);

  const fetchData = async () => {
    // localStorage.removeItem('auction_id')

    setActive(true);
    //  //console.log("fetch cid:" + cid);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };
    //  //console.log(aid)
    await DataService.plrforminfo({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;
        console.log("my response............");
        console.log(response);

        if (response.success == true) {
          //   let responsedata = response.data;
          //   setData(responsedata);

          //   dispatch(actlistData({ responsedata }));
          setData(response.data);
          // //  //console.log(field)
          if (response.data.cf != null && response.data.cf !== "" && Array.isArray(response.data.cf)) {
            setcuslist(response.data.cf);
          }
          if (response.data.info !== "") {
            setDescription(response.data.info);
          }
          if (response.data.pydetail !== "") {
            setPaymentDescription(response.data.pydetail);
          }

          // Set QR data if available
          //console.log('response.data.qrimg');
          //console.log(response.data);
          //console.log(response.data.qrimg);
          if (response.data) {
            setQrName(response.data.pyname || "");
            setQrUpiId(response.data.pymob || "");
            setPayButtonUpiId(response.data.pymob || "");
            const pyfee = response.data.pyfee;
            if (pyfee != null && typeof pyfee === "string" && (pyfee.trim().startsWith("[") || pyfee.trim().startsWith("{"))) {
              try {
                const parsed = JSON.parse(pyfee);
                if (Array.isArray(parsed) && parsed.length > 0) {
                  setQrFeesEntries(parsed.map((e) => ({
                    label: (e && e.label != null) ? String(e.label) : "Registration Fees",
                    value: (e && e.value != null) ? String(e.value) : ""
                  })));
                } else if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
                  setQrFeesEntries([{
                    label: parsed.label || "Registration Fees",
                    value: parsed.value != null ? String(parsed.value) : ""
                  }]);
                } else {
                  setQrFeesEntries([{ label: "Registration Fees", value: pyfee || "" }]);
                }
              } catch {
                setQrFeesEntries([{ label: "Registration Fees", value: pyfee || "" }]);
              }
            } else {
              setQrFeesEntries([{ label: "Registration Fees", value: pyfee != null ? String(pyfee) : "" }]);
            }
            //console.log('response.data.pyshow');
            //console.log(response.data.pyshow);
            setShowQR(String(response.data.pyshow) !== "0");

            // UTR: prefer platforminfo.utrno, then response.data.utrno; use as-is so s/r/l/p/t from API (e.g. s "0" = not shown)
            const utrnoRaw = response.data.platforminfo?.utrno ?? response.data.utrno;
            if (utrnoRaw != null && utrnoRaw !== "") {
              try {
                const p = typeof utrnoRaw === "string" ? JSON.parse(utrnoRaw) : utrnoRaw;
                if (p && typeof p === "object") {
                  const { k, o, ...rest } = p;
                  setUtrField({ s: "0", r: "0", l: "UTR No.", p: "", t: "1", ...rest });
                }
              } catch { /* keep default */ }
            }

            // Set WhatsApp link if available
            if (response.data.wtspgrplink) {
              setWhatsappLink(response.data.wtspgrplink);
            }

            // Load helpline data from JSON array (helpline field)
            if (response.data.helpline) {
              try {
                let helplineData = response.data.helpline;
                // Parse if it's a string
                if (typeof helplineData === 'string') {
                  helplineData = JSON.parse(helplineData);
                }

                if (Array.isArray(helplineData) && helplineData.length > 0) {
                  // First entry is main helpline
                  const firstEntry = helplineData[0];
                  if (firstEntry.name) {
                    setHelplineName(firstEntry.name);
                  }
                  if (firstEntry.mobile) {
                    setHelplineMobile(firstEntry.mobile);
                    setOriginalHelplineMobile(firstEntry.mobile);
                    // Check verification status
                    if (firstEntry.verified === "1" || firstEntry.verified === 1) {
                      setIsOtpVerified(true);
                    }
                  }

                  // Remaining entries are additional helplines
                  if (helplineData.length > 1) {
                    const additionalEntries = helplineData.slice(1).map((item, index) => ({
                      id: Date.now() + index, // Unique ID
                      name: item.name || "",
                      mobile: item.mobile || "",
                      originalMobile: item.mobile || "",
                      isVerified: item.verified === "1" || item.verified === 1,
                      showOtpInput: false,
                    }));
                    setHelplineEntries(additionalEntries);
                  }
                }
              } catch (error) {
                console.error("Error parsing helpline JSON:", error);
              }
            }

            // Fallback: Load from individual fields if helpline JSON not available
            if (response.data.helpline_name && !response.data.helpline) {
              setHelplineName(response.data.helpline_name);
            }
            if (response.data.helpline_mob && !response.data.helpline) {
              setHelplineMobile(response.data.helpline_mob);
              setOriginalHelplineMobile(response.data.helpline_mob);
              // Check if mobile was verified from API
              if (response.data.help_verified === "1" || response.data.help_verified === 1) {
                setIsOtpVerified(true);
              }
            }

            if (response.data.mrinfo) {
              setHelplineDescription(response.data.mrinfo);
            }
            if (response.data.subtext != null && response.data.subtext !== undefined) {
              setFormSubmittingText(response.data.subtext);
            }
            if (response.data.sublink !== undefined && response.data.sublink !== null) {
              setTermsAndConditions(response.data.sublink === "1" || response.data.sublink === 1);
            }
            if (response.data.subcont != null && response.data.subcont !== undefined) {
              setTermsAndConditionsContent(response.data.subcont);
            }

            // Set Payment method and bank details if available
            if (response.data.payment_method) {
              setPaymentMethod(response.data.payment_method);
            }
            if (response.data.pyname) {
              setQrName(response.data.pyname); // Account Name for both UPI and Bank
            }
            if (response.data.bank_acc) {
              setBankAccountNumber(response.data.bank_acc);
            }
            if (response.data.bank_ifsc) {
              setBankIfscCode(response.data.bank_ifsc);
            }

            // Set removeAuctionDate from platforminfo.isaucdthide
            if (response.data.platforminfo && response.data.platforminfo.isaucdthide) {
              setRemoveAuctionDate(response.data.platforminfo.isaucdthide === "1");
            } else if (response.data.isaucdthide) {
              // Fallback: check direct isaucdthide field
              setRemoveAuctionDate(response.data.isaucdthide === "1");
            }
          }

          response.data.df.map((ele) => {
            //  //console.log("ele")
            if (ele.k == 10 && ele.o) {
              // //console.log('sp1 found........')

              //  //console.log(value)
              setState((prev) => ({ ...prev, sp1Opt: ele.o.split(",") }));
            }
            if (ele.k == 11 && ele.o) {
              // //console.log('sp1 found........')
              //  //console.log(value)
              setState((prev) => ({ ...prev, sp2Opt: ele.o.split(",") }));
            }
            if (ele.k == 12 && ele.o) {
              // //console.log('sp1 found........')
              //  //console.log(value)
              setState((prev) => ({ ...prev, sp3Opt: ele.o.split(",") }));
            }
            Object.entries(field).forEach(([key, value]) => {
              //  //console.log('key...........')
              //  //console.log(key)
              //  //console.log(value)

              if (ele.k == value.k) {
                setfield((prevObjects) => {
                  return {
                    ...prevObjects,
                    [key]: ele,
                  };
                });
              }
            });
          });
        }

        setActive(false);
      })
      .catch(() => {
        //  //console.log("Not valid");
        setActive(false);
      });
  };

  useEffect(() => {
    fetchData();
    if (refresh == 1) {
      // fetchData(0);
    } else {
      if (getpageData == 0) {
        // fetchData(0);
      } else {
        if (getpageData.responsedata.cid == cid) {
          // fetchData(0)
          // setData(getpageData.responsedata);
        } else {
          let responsedata = getpageData.responsedata;
          responsedata.list = [];
          // setData(responsedata);
          // fetchData(0);
        }
      }
    }
    // if (localStorage.getItem('acode')) {
    //     var values = {
    //         'acode': localStorage.getItem('acode')
    //     }
    //     onSubmit(values);

    // }

    window.scrollTo(0, 0);
  }, [refresh]);
  const handleOptionChange = (event) => {
    if (event.target.value) setSelectedOption(event.target.value);
  };
  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
  };
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);

  function handlechange(l, option, val) {
    setfield((prevlOptions) => ({
      ...prevlOptions,
      [l]: {
        ...prevlOptions[l],
        [option]: val,
      },
    }));
  }
  function updateUtrField(option, val) {
    setUtrField((prev) => ({ ...prev, [option]: val }));
  }
  function handlecustomchange(l, option, val) {
    setcustomfield((prevlOptions) => ({
      ...prevlOptions,
      [l]: { ...prevlOptions[l], [option]: val },
    }));
  }

  const handleSendOtp = async () => {
    if (!helplineMobile || helplineMobile.trim() === "") {
      toast.error("Please enter mobile number first", {
        theme: "colored",
        position: "bottom-center",
      });
      return;
    }

    setIsSendingOtp(true);
    const loadingId = toast.loading("Sending OTP...", {
      theme: "dark",
      position: "bottom-center",
    });

    try {
      // Build URL with query parameters
      const params = new URLSearchParams({
        mobile: helplineMobile,
        aid: aid || 0,
      });
      const url = `https://superplayerauction.com/auctionapi/auction/sendotp/?${params.toString()}`;

      // Use fetch instead of axios to avoid CORS preflight issues
      const fetchResponse = await fetch(url, {
        method: 'GET',
        headers: {
          "Accept": "application/json",
        },
        mode: 'cors',
        credentials: 'omit',
      });

      if (!fetchResponse.ok) {
        throw new Error(`HTTP error! status: ${fetchResponse.status}`);
      }

      const response = { data: await fetchResponse.json() };
      toast.dismiss(loadingId);

      if (response.data.success) {
        toast.success("OTP sent successfully!", {
          theme: "dark",
          position: "bottom-center",
        });
        setShowOtpInput(true);
        setOtp("");
      } else {
        toast.error(response.data.msg || "Failed to send OTP", {
          theme: "colored",
          position: "bottom-center",
        });
      }
    } catch (error) {
      toast.dismiss(loadingId);
      const errorMessage = error.response?.data?.msg || error.message || "Error sending OTP. Please try again.";
      toast.error(errorMessage, {
        theme: "colored",
        position: "bottom-center",
      });
      console.error("Send OTP Error:", error.response?.data || error);
    } finally {
      setIsSendingOtp(false);
    }
  };

  // Add new helpline entry
  const handleAddHelplineEntry = () => {
    const newEntry = {
      id: Date.now(), // Unique ID
      name: "",
      mobile: "",
      originalMobile: "",
      isVerified: false,
      showOtpInput: false,
    };
    setHelplineEntries([...helplineEntries, newEntry]);
  };

  // Remove helpline entry
  const handleRemoveHelplineEntry = (id) => {
    setHelplineEntries(helplineEntries.filter(entry => entry.id !== id));
    // Clean up OTP input for this entry
    const newOtpInputs = { ...otpInputs };
    delete newOtpInputs[id];
    setOtpInputs(newOtpInputs);
  };

  // Update helpline entry field
  const handleUpdateHelplineEntry = (id, field, value) => {
    setHelplineEntries(helplineEntries.map(entry => {
      if (entry.id === id) {
        const updated = { ...entry, [field]: value };
        // If mobile changed, reset verification
        if (field === "mobile" && value !== entry.originalMobile) {
          updated.isVerified = false;
          updated.showOtpInput = false;
        }
        return updated;
      }
      return entry;
    }));
  };

  // Send OTP for specific helpline entry
  const handleSendOtpForEntry = async (entryId, mobile) => {
    if (!mobile || mobile.trim() === "") {
      toast.error("Please enter mobile number first", {
        theme: "colored",
        position: "bottom-center",
      });
      return;
    }

    setSendingOtpFor(entryId);
    const loadingId = toast.loading("Sending OTP...", {
      theme: "dark",
      position: "bottom-center",
    });

    try {
      const params = new URLSearchParams({
        mobile: mobile,
        aid: aid || 0,
      });
      const url = `https://superplayerauction.com/auctionapi/auction/sendotp/?${params.toString()}`;

      const fetchResponse = await fetch(url, {
        method: 'GET',
        headers: {
          "Accept": "application/json",
        },
        mode: 'cors',
        credentials: 'omit',
      });

      if (!fetchResponse.ok) {
        throw new Error(`HTTP error! status: ${fetchResponse.status}`);
      }

      const response = { data: await fetchResponse.json() };
      toast.dismiss(loadingId);

      if (response.data.success) {
        toast.success("OTP sent successfully!", {
          theme: "dark",
          position: "bottom-center",
        });
        handleUpdateHelplineEntry(entryId, "showOtpInput", true);
        setOtpInputs({ ...otpInputs, [entryId]: "" });
      } else {
        toast.error(response.data.msg || "Failed to send OTP", {
          theme: "colored",
          position: "bottom-center",
        });
      }
    } catch (error) {
      toast.dismiss(loadingId);
      const errorMessage = error.response?.data?.msg || error.message || "Error sending OTP. Please try again.";
      toast.error(errorMessage, {
        theme: "colored",
        position: "bottom-center",
      });
      console.error("Send OTP Error:", error.response?.data || error);
    } finally {
      setSendingOtpFor(null);
    }
  };

  // Verify OTP for specific helpline entry
  const handleVerifyOtpForEntry = async (entryId, mobile, otp) => {
    if (otp.length !== 4) {
      toast.error("Please enter complete 4-digit OTP", {
        theme: "colored",
        position: "bottom-center",
      });
      return;
    }

    setVerifyingOtpFor(entryId);
    const loadingId = toast.loading("Verifying OTP...", {
      theme: "dark",
      position: "bottom-center",
    });

    try {
      const params = new URLSearchParams({
        otp: otp,
        mobile: mobile,
        aid: aid || 0,
      });
      const url = `https://superplayerauction.com/auctionapi/auction/verifyotp/?${params.toString()}`;

      const fetchResponse = await fetch(url, {
        method: 'POST',
        headers: {
          "Accept": "application/json",
        },
        mode: 'cors',
        credentials: 'omit',
      });

      if (!fetchResponse.ok) {
        throw new Error(`HTTP error! status: ${fetchResponse.status}`);
      }

      const response = { data: await fetchResponse.json() };
      toast.dismiss(loadingId);

      if (response.data.success) {
        toast.success("Mobile number verified successfully!", {
          theme: "dark",
          position: "bottom-center",
        });
        // Update all fields at once using functional update to avoid stale state
        setHelplineEntries(prevEntries => prevEntries.map(entry => {
          if (entry.id === entryId) {
            return {
              ...entry,
              isVerified: true,
              showOtpInput: false,
              originalMobile: mobile
            };
          }
          return entry;
        }));
        setOtpInputs(prev => {
          const newOtpInputs = { ...prev };
          newOtpInputs[entryId] = "";
          return newOtpInputs;
        });
      } else {
        toast.error(response.data.msg || "Invalid OTP. Please try again.", {
          theme: "colored",
          position: "bottom-center",
        });
        setOtpInputs({ ...otpInputs, [entryId]: "" });
      }
    } catch (error) {
      toast.dismiss(loadingId);
      const errorMessage = error.response?.data?.msg || error.message || "Error verifying OTP. Please try again.";
      toast.error(errorMessage, {
        theme: "colored",
        position: "bottom-center",
      });
      console.error("Verify OTP Error:", error.response?.data || error);
      setOtpInputs({ ...otpInputs, [entryId]: "" });
    } finally {
      setVerifyingOtpFor(null);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter complete 4-digit OTP", {
        theme: "colored",
        position: "bottom-center",
      });
      return;
    }

    setIsVerifyingOtp(true);
    const loadingId = toast.loading("Verifying OTP...", {
      theme: "dark",
      position: "bottom-center",
    });

    try {
      // Build URL with query parameters (same format as sendotp)
      const params = new URLSearchParams({
        otp: otp,
        mobile: helplineMobile,
        aid: aid || 0,
      });
      const url = `https://superplayerauction.com/auctionapi/auction/verifyotp/?${params.toString()}`;

      // Use fetch instead of axios to avoid CORS preflight issues (same format as sendotp)
      const fetchResponse = await fetch(url, {
        method: 'POST',
        headers: {
          "Accept": "application/json",
        },
        mode: 'cors',
        credentials: 'omit',
      });

      if (!fetchResponse.ok) {
        throw new Error(`HTTP error! status: ${fetchResponse.status}`);
      }

      const response = { data: await fetchResponse.json() };
      toast.dismiss(loadingId);

      if (response.data.success) {
        toast.success("Mobile number verified successfully!", {
          theme: "dark",
          position: "bottom-center",
        });
        setIsOtpVerified(true);
        setShowOtpInput(false);
        // Update original mobile number after verification
        setOriginalHelplineMobile(helplineMobile);
      } else {
        toast.error(response.data.msg || "Invalid OTP. Please try again.", {
          theme: "colored",
          position: "bottom-center",
        });
        setOtp("");
      }
    } catch (error) {
      toast.dismiss(loadingId);
      const errorMessage = error.response?.data?.msg || error.message || "Error verifying OTP. Please try again.";
      toast.error(errorMessage, {
        theme: "colored",
        position: "bottom-center",
      });
      console.error("Verify OTP Error:", error.response?.data || error);
      setOtp("");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const postfield = async () => {
    setActive(true);

    // Validation: At least one fee entry with value is mandatory if Payment is enabled (showQR is true)
    const hasValidFee = showQR && qrFeesEntries.some((e) => e.value != null && String(e.value).trim() !== "");
    if (showQR && !hasValidFee) {
      toast.error("At least one fee (label + value) is mandatory when Payment is enabled.", {
        theme: "colored",
        position: "bottom-center"
      });
      setActive(false);
      return;
    }

    var hdr = {
      headers: {
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    var farr = [];

    ls.map((ele) => {
      farr.push(field[ele]);
    });

    let exitFunction = false;
    cuslist.map((ele) => {
      if (ele.t && ele.t == "2") {
        if (ele.o == undefined) {
          alert("Set options for " + ele.l);
          exitFunction = true;
          setActive(false);
          return;
        }
      }
    });
    if (exitFunction) {
      return; // Exit the function
    }

    const id = toast.loading("Please wait...");
    cuslist.map((ele) => {
      if (ele.t == undefined) {
        ele.t = "0";
      }
    });

    let finalCusList = [...cuslist];

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    const jsonString = JSON.stringify(farr);
    const jsonString2 = JSON.stringify(finalCusList);

    // Create FormData to handle file upload
    const formData = new FormData();
    formData.append("df_f", jsonString);
    formData.append("custom_f", jsonString2);
    formData.append("info", description);
    formData.append("utrno", JSON.stringify(utrField));

    // Append the QR image file if it exists
    if (qrImage) {
      formData.append("qrimg", qrImage);
    }

    // pydetail = payment description HTML only (do not append Registration Fees here)
    formData.append("pydetail", paymentDescription);
    // formData.append("pyname", qrName);
    formData.append("pymob", (payButtonUpiId && String(payButtonUpiId).trim()) ? String(payButtonUpiId).trim() : (qrUpiId || ""));
    formData.append("pyfee", JSON.stringify(qrFeesEntries.map((e) => ({ label: (e.label && String(e.label).trim()) || "Registration Fees", value: e.value }))));
    formData.append("pyshow", showQR ? "1" : "0");

    // Add WhatsApp invite link
    formData.append("wtspgrplink", whatsappLink);

    // Add Helpline information
    formData.append("helpline_name", helplineName);
    // Only send helpline_mob if OTP is verified, otherwise send blank
    // formData.append("helpline_mob", isOtpVerified ? helplineMobile : "");
    formData.append("helpline_mob", helplineMobile);
    formData.append("help_verified", isOtpVerified ? "1" : "0");

    // Prepare helpline JSON array with all helpline entries (main + additional)
    const helplineArray = [];

    // Add main helpline if name and mobile are provided
    if (helplineName && helplineName.trim() !== "" && helplineMobile && helplineMobile.trim() !== "") {
      helplineArray.push({
        name: helplineName.trim(),
        mobile: helplineMobile.trim(),
        verified: isOtpVerified ? "1" : "0"
      });
    }

    // Add additional helpline entries
    helplineEntries.forEach(entry => {
      if (entry.name && entry.name.trim() !== "" && entry.mobile && entry.mobile.trim() !== "") {
        helplineArray.push({
          name: entry.name.trim(),
          mobile: entry.mobile.trim(),
          verified: entry.isVerified ? "1" : "0"
        });
      }
    });

    // Send helpline JSON array (always send, even if empty)
    formData.append("helpline", JSON.stringify(helplineArray));
    formData.append("mrinfo", helplineDescription);
    formData.append("subtext", formSubmittingText || "");
    formData.append("sublink", termsAndConditions ? "1" : "0");
    formData.append("subcont", termsAndConditionsContent || "");

    // Add Payment method and details
    formData.append("payment_method", paymentMethod);
    formData.append("pyname", qrName); // Account Name for both UPI and Bank
    formData.append("isaucdthide", removeAuctionDate ? "1" : "0");
    formData.append("isadmin", admin_id ? "1" : "0");
    if (paymentMethod === "bank") {
      formData.append("bank_acc", bankAccountNumber);
      formData.append("bank_ifsc", bankIfscCode);
    }

    await DataService.setplrform(formData, hdr)
      .then((res) => {
        let response = res.data;
        //console.log("custom resp");
        //console.log(response);
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          if (aucmoredetail != 0) {
            aucmoredetail.extra = cuslist;
            dispatch(actmore(aucmoredetail));
          }
          toast.success("Updated successfully", {
            theme: "dark",
            position: "bottom-center",
          });
          // Update original mobile number after successful save
          setOriginalHelplineMobile(helplineMobile);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  function updcustlbl(i, v) {
    const updatedList = cuslist.map((ele, index) =>
      index === i ? { ...ele, l: v } : ele
    );
    //  //console.log(updatedList)
    setcuslist(updatedList);
  }
  function updcustreq(i, v) {
    const updatedList = cuslist.map((ele, index) =>
      index === i ? { ...ele, r: v } : ele
    );
    setcuslist(updatedList);
    //  //console.log(updatedList)
  }
  function updinptype(i, v) {
    setSelectedOption(v);
    if (v == 2) {
      setisoptpopup(i);
    } else {
      setisoptpopup(0);
    }
    const updatedList = cuslist.map((ele, index) =>
      index === i ? { ...ele, t: v } : ele
    );
    setcuslist(updatedList);
    //  //console.log(updatedList)
  }
  function updcusts(i, v) {
    const updatedList = cuslist.map((ele, index) =>
      index === i ? { ...ele, s: v } : ele
    );
    setcuslist(updatedList);
  }
  function updopt(i, v) {
    //console.log("cuslist");
    //console.log(cuslist);
    //console.log(i);
    const updatedList = cuslist.map((ele, index) =>
      index === i ? { ...ele, o: v } : ele
    );
    setcuslist(updatedList);
    setisoptpopup(0);
  }
  function addcustomfield() {
    setcuslist((prev) => [
      ...prev,
      {
        s: "1",
        r: "0",
        l: "",
        p: "",
        t: "0",
      },
    ]);
  }
  function delcustom(i) {
    const updatedList = cuslist.filter((ele, index) => index !== i);
    setcuslist(updatedList);
  }

  const handleCustomUpdate = (index, field, value) => {
    //console.log("handleCustomUpdate called:", index, field, value);

    if (field === "showOptions") {
      //console.log("Setting popup for index:", index + 1);
      setisoptpopup(index + 1);
      const currentField = cuslist[index];
      setoptval(currentField.o || "");
      return;
    }

    const updatedList = cuslist.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setcuslist(updatedList);
  };

  // Function to handle saving options
  const handleSaveOptions = (index) => {
    const updatedList = cuslist.map((item, i) =>
      i === index - 1 ? { ...item, o: optval } : item
    );
    setcuslist(updatedList);
    setisoptpopup(null);
    setoptval("");
  };

  // Add QR image handler
  const handleQRUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setQrImage(file);

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setQrPreview(previewUrl);

      // Simulate QR scanning - we'll just show animation and feedback
      setQrScanSimulation("scanning");

      // Check if file size is appropriate
      const validSize = file.size < 500000; // Less than 500KB

      // Simulate processing time
      setTimeout(() => {
        setQrScanSimulation(validSize ? "success" : "warning");
      }, 1500);
    }
  };

  return (
    <LoadingOverlay
      active={isActive}
      spinner={<BounceLoader color="#337ab7" />}
    >
      <PageContainer className="customize_css">
        <FormContainer>
          <Navigationtitle data={match} />

          <StyledTabs>
            <TabList>
              <Tab>Default Fields</Tab>
              <Tab>Custom Fields</Tab>
              <Tab>Add Description</Tab>
              <Tab>For Payment</Tab>
              <Tab>Messages</Tab>
              <Tab>Settings</Tab>
              {/* <Tab>Extra</Tab> */}
            </TabList>

            <TabPanel>
              <FieldsGrid>
                {ls.map((key) => (
                  <FormField
                    key={key}
                    label={defaultLabels[key]}
                    field={field[key]}
                    state={state}
                    setState={setState}
                    updateState={updateState}
                    addItem={addItem}
                    removeOption={removeOption}
                    setfield={setfield}
                    onChange={(k, option, val) =>
                      handlechange(key, option, val)
                    }
                  />
                ))}
              </FieldsGrid>

              {/* Receipt Section */}
              {field.receipt && field.receipt.s === "1" && (
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "1.5rem 2rem",
                    marginTop: "1.5rem",
                    textAlign: "center",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "1rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <span
                      style={{
                        color: "#64748b",
                        fontSize: "1.2rem",
                        fontWeight: 500,
                      }}
                    >
                      You can check receipts here:
                    </span>
                    <a
                      href={`https://superplayerauction.com/playerreceipt.php?actid=${aid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#3b82f6",
                        fontSize: "1.2rem",
                        textDecoration: "underline",
                        fontWeight: 500,
                        wordBreak: "break-all",
                      }}
                    >
                      https://superplayerauction.com/playerreceipt.php?actid=
                      {aid}
                    </a>
                    <button
                      onClick={() => {
                        const receiptUrl = `https://superplayerauction.com/playerreceipt.php?actid=${aid}`;
                        navigator.clipboard
                          .writeText(receiptUrl)
                          .then(() => {
                            toast.success("Link copied to clipboard!", {
                              theme: "dark",
                              position: "bottom-center",
                              autoClose: 2000,
                            });
                          })
                          .catch(() => {
                            toast.error("Failed to copy link", {
                              theme: "colored",
                              position: "bottom-center",
                            });
                          });
                      }}
                      style={{
                        background: "#eff6ff",
                        border: "1px solid #3b82f6",
                        borderRadius: "6px",
                        padding: "0.5rem 0.75rem",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "#3b82f6",
                        fontSize: "1.2rem",
                        fontWeight: 500,
                        transition: "all 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = "#3b82f6";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = "#eff6ff";
                        e.target.style.color = "#3b82f6";
                      }}
                      title="Copy link"
                    >
                      <AiIcons.AiOutlineCopy />
                      Copy
                    </button>
                  </div>
                </div>
              )}
            </TabPanel>

            <TabPanel>
              <FieldsGrid>
                {(cuslist || []).map((field, index) => (
                  <CustomField
                    key={index}
                    field={field}
                    index={index}
                    onUpdate={handleCustomUpdate}
                    onDelete={delcustom}
                  />
                ))}
              </FieldsGrid>

              <div className="actions-bar">
                <ActionButton className="primary" onClick={addcustomfield}>
                  Add New Custom Field
                </ActionButton>
              </div>
            </TabPanel>

            <TabPanel>
              <DescriptionContainer>
                <h3>Form Description</h3>
                <p className="description-helper">
                  Add a description that will be displayed at the top of your
                  form.
                </p>

                <div className="quill-wrapper">
                  <ReactQuill
                    value={description}
                    onChange={setDescription}
                    modules={modules}
                    formats={formats}
                    placeholder="Enter form description here..."
                  />
                </div>
              </DescriptionContainer>
            </TabPanel>

            <TabPanel>

              <QRUploadContainer>
                <QRHeaderContainer>
                  <div className="header-left">
                    <h3>Payment Details</h3>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <QRToggleContainer>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={showQR}
                          onChange={(e) => {
                            setShowQR(e.target.checked);
                            // Reset scan simulation if turning off QR display
                            if (!e.target.checked) {
                              setQrScanSimulation(null);
                            }
                          }}
                        />
                        <span className="slider"></span>
                      </label>
                    </QRToggleContainer>
                  </div>
                </QRHeaderContainer>

                {showQR && (
                  <>
                    <input
                      type="file"
                      id="qr-upload"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;

                        setQrImage(file);
                        setQrPreview(URL.createObjectURL(file));
                        setQrName(file.name);
                      }}
                    />

                    <div style={{ display: "flex", gap: "20px" }}>


                      <div className="quill-wrapper" style={{ width: "73%" }}>
                        <ReactQuill
                          value={paymentDescription}
                          onChange={setPaymentDescription}
                          modules={modules}
                          formats={formats}
                          placeholder="Enter Payment description here..."
                        />
                        {showQR && (
                          <div style={{
                            marginTop: "15px",
                            padding: "12px 15px",
                            backgroundColor: "#f8fafc",
                            border: "1px solid #e2e8f0",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            justifyContent: "space-evenly",
                            gap: "16px",
                            flexWrap: "wrap"
                          }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "12px", width: "100%" }}>
                              {qrFeesEntries.map((entry, idx) => (
                                <div key={idx} style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                                  <input
                                    type="text"
                                    placeholder="Label (e.g. Bacho ke liye, Bade ke liye)"
                                    value={entry.label}
                                    onChange={(e) => {
                                      const next = [...qrFeesEntries];
                                      next[idx] = { ...next[idx], label: e.target.value };
                                      setQrFeesEntries(next);
                                    }}
                                    style={{
                                      width: "180px",
                                      padding: "8px 12px",
                                      border: "1px solid #cbd5e1",
                                      borderRadius: "6px",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      color: "#1e293b",
                                      fontWeight: "500",
                                      transition: "all 0.2s",
                                    }}
                                    onFocus={(e) => {
                                      e.target.style.borderColor = "#3b82f6";
                                      e.target.style.boxShadow = "0 0 0 2px rgba(59, 130, 246, 0.1)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.borderColor = "#cbd5e1";
                                      e.target.style.boxShadow = "none";
                                    }}
                                  />
                                  <span style={{ fontSize: "15px", color: "#64748b" }}>:</span>
                                  <input
                                    type="text"
                                    placeholder="e.g. 500, ₹1000, 500/1000, AED 50"
                                    value={entry.value}
                                    onChange={(e) => {
                                      const next = [...qrFeesEntries];
                                      next[idx] = { ...next[idx], value: e.target.value };
                                      setQrFeesEntries(next);
                                    }}
                                    style={{
                                      width: aid === "61748" ? "220px" : "150px",
                                      padding: "8px 12px",
                                      border: "1px solid #cbd5e1",
                                      borderRadius: "6px",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      color: "#1e293b",
                                      fontWeight: "500",
                                      transition: "all 0.2s",
                                    }}
                                    onFocus={(e) => {
                                      e.target.style.borderColor = "#3b82f6";
                                      e.target.style.boxShadow = "0 0 0 2px rgba(59, 130, 246, 0.1)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.borderColor = "#cbd5e1";
                                      e.target.style.boxShadow = "none";
                                    }}
                                  />
                                  {qrFeesEntries.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() => setQrFeesEntries(qrFeesEntries.filter((_, i) => i !== idx))}
                                      style={{
                                        padding: "6px 10px",
                                        border: "1px solid #fecaca",
                                        borderRadius: "6px",
                                        background: "#fef2f2",
                                        color: "#dc2626",
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                      title="Remove this fee row"
                                    >
                                      <RxCross2 size={16} />
                                    </button>
                                  )}
                                  {idx === qrFeesEntries.length - 1 && (
                                    <button
                                      type="button"
                                      onClick={() => setQrFeesEntries([...qrFeesEntries, { label: "", value: "" }])}
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        padding: "6px 12px",
                                        border: "1px solid #22c55e",
                                        borderRadius: "6px",
                                        background: "#22c55e",
                                        color: "#ffffff",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                      }}
                                      title="Add another fee"
                                    >
                                      <FontAwesomeIcon icon={faPlus} style={{ fontSize: "14px" }} />
                                      Add fee
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                            {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <label style={{ fontSize: "15px", fontWeight: "500", color: "#334155", whiteSpace: "nowrap" }}>
                                  UPI ID (Pay):
                                </label>
                                <input
                                  type="text"
                                  placeholder="UPI ID for Pay"
                                  value={payButtonUpiId}
                                  onChange={(e) => setPayButtonUpiId(e.target.value)}
                                  style={{
                                    width: "180px",
                                    padding: "8px 12px",
                                    border: "1px solid #cbd5e1",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    backgroundColor: "#ffffff",
                                    color: "#1e293b",
                                    fontWeight: "500",
                                    transition: "all 0.2s",
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = "#3b82f6";
                                    e.target.style.boxShadow = "0 0 0 2px rgba(59, 130, 246, 0.1)";
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = "#cbd5e1";
                                    e.target.style.boxShadow = "none";
                                  }}
                                />
                              </div> */}
                          </div>
                        )}
                      </div>


                      <div
                        style={{
                          width: "27%",
                          background: "#ffffff",
                          padding: "15px",
                          borderRadius: "12px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                          height: "fit-content",
                          textAlign: "left"
                        }}
                      >

                        <div
                          style={{
                            display: "flex",
                            border: "1px solid #dcdcdc",
                            borderRadius: "8px",
                            overflow: "hidden",
                            marginBottom: "15px",
                          }}
                        >
                          <div
                            onClick={() => setActiveTab("detail1")}
                            style={{
                              flex: 1,
                              padding: "10px",
                              textAlign: "center",
                              cursor: "pointer",
                              background: activeTab === "detail1" ? "#f2f2f2" : "#ffffff",
                              borderRight: "1px solid #dcdcdc",
                              fontWeight: activeTab === "detail1" ? "600" : "500",
                              transition: "0.2s",
                            }}
                          >
                            Detail 1
                          </div>

                          <div
                            onClick={() => setActiveTab("detail2")}
                            style={{
                              flex: 1,
                              padding: "10px",
                              textAlign: "center",
                              cursor: "pointer",
                              background: activeTab === "detail2" ? "#f2f2f2" : "#ffffff",
                              fontWeight: activeTab === "detail2" ? "600" : "500",
                              transition: "0.2s",
                            }}
                          >
                            Detail 2
                          </div>
                        </div>



                        {activeTab === "detail1" && (
                          <>
                            <div >
                              <strong>Account Holder:</strong>
                              John Doe
                            </div>

                            <div >
                              <strong>Account Number:</strong>
                              1234 5678 9012
                            </div>

                            <div >
                              <strong>Bank Name:</strong>
                              HDFC Bank
                            </div>

                            <div >
                              <strong>IFSC Code:</strong>
                              HDFC0001234
                            </div>

                            <div >
                              <strong>Amount / Fees:</strong>
                              ₹500
                            </div>
                          </>
                        )}

                        {activeTab === "detail2" && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <strong>Account Name:</strong>
                              Raj Sharma
                            </div>
                            <div style={{ marginBottom: "8px" }}>
                              <strong>UPI ID:</strong>
                              rajsharma@upi
                            </div>

                            <div style={{ marginBottom: "8px" }}>
                              <strong>Amount / Fees:</strong>
                              ₹750
                            </div>
                          </>
                        )}

                        <hr style={{ margin: "12px 0" }} />

                        <p style={{ fontSize: "13px", opacity: 0.8 }}>
                          Use this sample as a guide and write your details in the editor.
                        </p>
                      </div>

                    </div>
                    <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "flex-start", gap: "1.5rem", flexWrap: "wrap", width: "100%" }}>
                      <div style={{ minWidth: "260px", flex: "1 1 260px", marginTop: "2rem" }}>
                        <FieldCard>
                          <FieldHeader>
                            <FieldLabel>{(utrField.l || "utr").toUpperCase()}</FieldLabel>
                            <div className="field-actions">
                              <button
                                type="button"
                                onClick={() => updateUtrField("s", utrField.s === "1" ? "0" : "1")}
                                style={{ border: "none", background: "none", color: "#3b82f6", cursor: "pointer", padding: "4px" }}
                                aria-label={utrField.s === "1" ? "Hide" : "Show"}
                              >
                                {utrField.s === "1" ? <Eye className="w-5 h-5" /> : <EyeOff className="w-5 h-5" />}
                              </button>
                            </div>
                          </FieldHeader>
                          <ControlsGrid>
                            <div className="control-group">
                              <input
                                type="text"
                                value={utrField.l || ""}
                                onChange={(e) => updateUtrField("l", e.target.value)}
                                placeholder="UTR"
                                className="label-input"
                              />
                            </div>
                            <div className="control-group spec-field">
                              <input
                                type="text"
                                value={utrField.p || ""}
                                onChange={(e) => updateUtrField("p", e.target.value)}
                                placeholder="Text value"
                                className="placeholder-input"
                              />
                            </div>
                            <div className="control-group checkbox-container" style={{ gridColumn: "1 / -1" }}>
                              <label className="checkbox-label checkbox-label-new">
                                <input
                                  type="checkbox"
                                  checked={utrField.r === "1"}
                                  onChange={(e) => updateUtrField("r", e.target.checked ? "1" : "0")}
                                />
                                <span>Required</span>
                              </label>
                            </div>
                          </ControlsGrid>
                        </FieldCard>
                      </div>

                      <div className="rgh" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem", minWidth: "200px", flex: "1 1 200px" }}>
                        <QRButtonContainer className="qr-upload-btn-container">
                          <ActionButton
                            className={`secondary ${qrImage || data.qrimg ? "jkl" : ""}`}
                            onClick={() => document.getElementById("qr-upload").click()}
                          >
                            {qrImage || data.qrimg ? "Change QR Code" : "Upload QR Code"}
                          </ActionButton>
                          {(qrImage || data.qrimg) && (
                            <RemoveButton
                              className={`secondary ${qrImage || data.qrimg ? "jkl" : ""}`}
                              onClick={() => {
                                if (data.qrimg) {
                                  const loadingId = toast.loading("Removing QR code...");
                                  const hdr = {
                                    headers: {
                                      "Content-Type": "application/x-www-form-urlencoded",
                                      authorization: JSON.stringify([
                                        { cid: cid, token: loginuser["token"] }
                                      ]),
                                    },
                                  };
                                  const formData = new FormData();
                                  formData.append("aid", aid);
                                  DataService.removeQrImage(formData, hdr)
                                    .then((res) => {
                                      toast.dismiss(loadingId);
                                      if (res.data.success) {
                                        toast.success("QR code removed successfully", {
                                          theme: "dark",
                                          position: "bottom-center",
                                        });
                                        setQrImage(null);
                                        setQrPreview(null);
                                        setQrName("");
                                        setQrUpiId("");
                                        setQrFeesEntries([{ label: "Registration Fees", value: "" }]);
                                        setQrScanSimulation(null);
                                        setData((prev) => ({ ...prev, qrimg: null }));
                                      } else {
                                        toast.error(res.data.msg || "Failed to remove QR code", {
                                          theme: "colored",
                                        });
                                      }
                                    })
                                    .catch(() => {
                                      toast.dismiss(loadingId);
                                      toast.error("Server error while removing QR", {
                                        theme: "colored",
                                      });
                                    });
                                } else {
                                  setQrImage(null);
                                  setQrPreview(null);
                                  setQrName("");
                                  setQrUpiId("");
                                  setQrFeesEntries([{ label: "Registration Fees", value: "" }]);
                                  setQrScanSimulation(null);
                                  toast.success("QR removed from form", {
                                    theme: "dark",
                                    position: "bottom-center",
                                  });
                                }
                              }}
                            >
                              Remove QR
                            </RemoveButton>
                          )}
                        </QRButtonContainer>

                        {qrPreview && (
                          <div className="qr-preview">
                            <img
                              src={qrPreview}
                              alt="QR Preview"
                              style={{ width: 200, marginTop: 20 }}
                            />
                          </div>
                        )}
                        {data.qrimg && !qrImage && (
                          <div className="qr-preview">
                            <img
                              src={data.path && data.qrimg ? `${data.path}${data.qrimg}` : data.qrimg}
                              alt="Saved QR Code"
                              style={{ width: 200, marginTop: 20 }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </QRUploadContainer>
            </TabPanel>

            <TabPanel>
              <WhatsAppContainer>
                <h3>WhatsApp Group Invitation</h3>
                <div className="whatsapp-instructions">
                  <ul className="whatsapp-benefits-list">
                    <li>
                      <strong>Automatic Messaging:</strong> WhatsApp messages
                      will be sent to players when they register for this
                      tournament
                    </li>
                    <li>
                      <strong>Message Content:</strong> Includes tournament
                      name, WhatsApp group link, and enquiry number
                    </li>
                    {/* <li>
                      <strong>Cost:</strong>{" "}
                      <span className="pricing-highlight">
                        ₹0.50 per player
                      </span>
                    </li> */}
                  </ul>
                </div>
                <div className="whatsapp-link-container">
                  <WhatsAppLinkInput
                    type="text"
                    placeholder="Paste your WhatsApp group invite link (https://chat.whatsapp.com/...)"
                    value={whatsappLink}
                    onChange={(e) => setWhatsappLink(e.target.value)}
                    className={
                      whatsappLink &&
                        !whatsappLink.includes("chat.whatsapp.com")
                        ? "error"
                        : ""
                    }
                  />

                  {whatsappLink &&
                    !whatsappLink.includes("chat.whatsapp.com") && (
                      <div className="whatsapp-error">
                        Please enter a valid WhatsApp group invite link. It
                        should contain "chat.whatsapp.com".
                      </div>
                    )}

                  {/* {whatsappLink && whatsappLink.includes("chat.whatsapp.com") && (
                    <div className="whatsapp-link-preview">
                      {whatsappLink}
                    </div>
                  )} */}

                  {(!whatsappLink ||
                    !whatsappLink.includes("chat.whatsapp.com")) && (
                      <div className="whatsapp-info">
                        <div className="whatsapp-info-icon">
                          <AiIcons.AiOutlineInfoCircle />
                        </div>
                        <div className="whatsapp-info-text">
                          <p>
                            <strong style={{ fontSize: "1.5rem", marginLeft: "-1.0rem" }}>
                              How to get a WhatsApp group invite link:
                            </strong>
                          </p>
                          <ol>
                            <li>Open the WhatsApp group on your phone</li>
                            <li>Tap the group name at the top</li>
                            <li>
                              Scroll down and tap "Invite to Group via Link"
                            </li>
                            <li>Choose "Copy Link" and paste it here</li>
                          </ol>
                        </div>
                      </div>
                    )}
                </div>
              </WhatsAppContainer>
            </TabPanel>

            <TabPanel>
              <HelplineContainer>
                <h3>Helpline Information</h3>
                <div className="helpline-fields">
                  <div className="helpline-field">
                    <label htmlFor="helplineName">Name</label>
                    <input
                      type="text"
                      id="helplineName"
                      placeholder="Enter helpline contact name"
                      className="helpline-input"
                      value={helplineName}
                      onChange={(e) => setHelplineName(e.target.value)}
                    />
                  </div>
                  <div className="helpline-field">
                    <label htmlFor="helplineMobile">Mobile Number</label>
                    <div style={{ position: "relative", width: "100%" }}>
                      <input
                        type="tel"
                        id="helplineMobile"
                        placeholder="Enter helpline mobile number"
                        className="helpline-input"
                        value={helplineMobile}
                        onChange={(e) => {
                          setHelplineMobile(e.target.value);
                          setIsOtpVerified(false);
                          setShowOtpInput(false);
                          setOtp("");
                        }}
                        style={{
                          width: "100%",
                          paddingRight: (helplineMobile && helplineMobile.trim() !== "" && helplineMobile !== originalHelplineMobile) ? "100px" : "1.5rem",
                        }}
                      />
                      {helplineMobile && helplineMobile.trim() !== "" && helplineMobile !== originalHelplineMobile && (
                        <button
                          type="button"
                          onClick={handleSendOtp}
                          disabled={isSendingOtp || isOtpVerified}
                          style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            padding: "8px 16px",
                            backgroundColor: isOtpVerified ? "#10b981" : "#186cc2",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: isSendingOtp || isOtpVerified ? "not-allowed" : "pointer",
                            fontWeight: "600",
                            fontSize: "13px",
                            opacity: isSendingOtp || isOtpVerified ? 0.6 : 1,
                            transition: "all 0.3s ease",
                            whiteSpace: "nowrap",
                            zIndex: 10,
                          }}
                          onMouseEnter={(e) => {
                            if (!isSendingOtp && !isOtpVerified) {
                              e.target.style.backgroundColor = "#155a9e";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isOtpVerified) {
                              e.target.style.backgroundColor = "#186cc2";
                            }
                          }}
                        >
                          {isOtpVerified ? "✓ Verified" : isSendingOtp ? "Sending..." : "Verify"}
                        </button>
                      )}
                    </div>
                    {showOtpInput && !isOtpVerified && (
                      <div style={{ marginTop: "15px", padding: "15px", backgroundColor: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                        {/* <label htmlFor="otpInput" style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "500", color: "#374151" }}>
                          Enter OTP
                        </label> */}
                        <div style={{ display: "flex", gap: "10px" }}>
                          <input
                            type="text"
                            id="otpInput"
                            placeholder="Enter 4-digit OTP"
                            value={otp}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "").slice(0, 4);
                              setOtp(value);
                            }}
                            style={{
                              flex: 1,
                              padding: "10px 15px",
                              border: "1px solid #cbd5e1",
                              borderRadius: "6px",
                              fontSize: "16px",
                              letterSpacing: "4px",
                              textAlign: "center",
                            }}
                            maxLength={4}
                          />
                          <button
                            type="button"
                            onClick={handleVerifyOtp}
                            disabled={otp.length !== 4 || isVerifyingOtp}
                            style={{
                              padding: "10px 24px",
                              backgroundColor: otp.length === 4 && !isVerifyingOtp ? "#10b981" : "#9ca3af",
                              color: "white",
                              border: "none",
                              borderRadius: "6px",
                              cursor: otp.length === 4 && !isVerifyingOtp ? "pointer" : "not-allowed",
                              fontWeight: "600",
                              fontSize: "14px",
                              transition: "all 0.3s ease",
                              whiteSpace: "nowrap",
                            }}
                            onMouseEnter={(e) => {
                              if (otp.length === 4 && !isVerifyingOtp) {
                                e.target.style.backgroundColor = "#059669";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (otp.length === 4 && !isVerifyingOtp) {
                                e.target.style.backgroundColor = "#10b981";
                              }
                            }}
                          >
                            {isVerifyingOtp ? "Verifying..." : "Confirm"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Multiple Helpline Entries */}
                  {helplineEntries.map((entry) => (
                    <React.Fragment key={entry.id}>
                      <div className="helpline-field" style={{ marginTop: "-8px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
                          <label htmlFor={`helplineName_${entry.id}`} style={{ margin: 0 }}>Name</label>

                        </div>
                        <input
                          type="text"
                          id={`helplineName_${entry.id}`}
                          placeholder="Enter helpline contact name"
                          className="helpline-input"
                          value={entry.name}
                          onChange={(e) => handleUpdateHelplineEntry(entry.id, "name", e.target.value)}
                        />
                      </div>
                      <div className="helpline-field" style={{ marginTop: "-13px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
                          <label htmlFor={`helplineMobile_${entry.id}`}>Mobile Number</label>
                          <button
                            type="button"
                            onClick={() => handleRemoveHelplineEntry(entry.id)}
                            style={{
                              padding: "0px 10px",
                              backgroundColor: "#ef4444",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "12px",
                              fontWeight: "500",
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = "#dc2626"}
                            onMouseLeave={(e) => e.target.style.backgroundColor = "#ef4444"}
                          >
                            Remove
                          </button>
                        </div>
                        <div style={{ position: "relative", width: "100%" }}>
                          <input
                            type="tel"
                            id={`helplineMobile_${entry.id}`}
                            placeholder="Enter helpline mobile number"
                            className="helpline-input"
                            value={entry.mobile}
                            onChange={(e) => handleUpdateHelplineEntry(entry.id, "mobile", e.target.value)}
                            style={{
                              width: "100%",
                              paddingRight: (entry.mobile && entry.mobile.trim() !== "" && (entry.isVerified || entry.mobile !== entry.originalMobile)) ? "100px" : "1.5rem",
                            }}
                          />
                          {entry.mobile && entry.mobile.trim() !== "" && (
                            <>
                              {entry.isVerified ? (
                                <button
                                  type="button"
                                  disabled
                                  style={{
                                    position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    padding: "8px 16px",
                                    backgroundColor: "#10b981",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "not-allowed",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    opacity: 0.6,
                                    transition: "all 0.3s ease",
                                    whiteSpace: "nowrap",
                                    zIndex: 10,
                                  }}
                                >
                                  ✓ Verified
                                </button>
                              ) : entry.mobile !== entry.originalMobile ? (
                                <button
                                  type="button"
                                  onClick={() => handleSendOtpForEntry(entry.id, entry.mobile)}
                                  disabled={sendingOtpFor === entry.id}
                                  style={{
                                    position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    padding: "8px 16px",
                                    backgroundColor: "#186cc2",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: sendingOtpFor === entry.id ? "not-allowed" : "pointer",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    opacity: sendingOtpFor === entry.id ? 0.6 : 1,
                                    transition: "all 0.3s ease",
                                    whiteSpace: "nowrap",
                                    zIndex: 10,
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!sendingOtpFor) {
                                      e.target.style.backgroundColor = "#155a9e";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "#186cc2";
                                  }}
                                >
                                  {sendingOtpFor === entry.id ? "Sending..." : "Verify"}
                                </button>
                              ) : null}
                            </>
                          )}
                        </div>
                        {entry.showOtpInput && !entry.isVerified && (
                          <div style={{ marginTop: "15px", padding: "15px", backgroundColor: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <input
                                type="text"
                                placeholder="Enter 4-digit OTP"
                                value={otpInputs[entry.id] || ""}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, "").slice(0, 4);
                                  setOtpInputs({ ...otpInputs, [entry.id]: value });
                                }}
                                style={{
                                  flex: 1,
                                  padding: "10px 15px",
                                  border: "1px solid #cbd5e1",
                                  borderRadius: "6px",
                                  fontSize: "16px",
                                  letterSpacing: "4px",
                                  textAlign: "center",
                                }}
                                maxLength={4}
                              />
                              <button
                                type="button"
                                onClick={() => handleVerifyOtpForEntry(entry.id, entry.mobile, otpInputs[entry.id] || "")}
                                disabled={(otpInputs[entry.id] || "").length !== 4 || verifyingOtpFor === entry.id}
                                style={{
                                  padding: "10px 24px",
                                  backgroundColor: (otpInputs[entry.id] || "").length === 4 && verifyingOtpFor !== entry.id ? "#10b981" : "#9ca3af",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "6px",
                                  cursor: (otpInputs[entry.id] || "").length === 4 && verifyingOtpFor !== entry.id ? "pointer" : "not-allowed",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  transition: "all 0.3s ease",
                                  whiteSpace: "nowrap",
                                }}
                                onMouseEnter={(e) => {
                                  if ((otpInputs[entry.id] || "").length === 4 && verifyingOtpFor !== entry.id) {
                                    e.target.style.backgroundColor = "#059669";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if ((otpInputs[entry.id] || "").length === 4 && verifyingOtpFor !== entry.id) {
                                    e.target.style.backgroundColor = "#10b981";
                                  }
                                }}
                              >
                                {verifyingOtpFor === entry.id ? "Verifying..." : "Confirm"}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  ))}

                  {/* Add More Helpline Button */}
                  <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <button
                      type="button"
                      onClick={handleAddHelplineEntry}
                      style={{
                        padding: "12px 24px",
                        backgroundColor: "#10b981",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        margin: "0 auto",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#059669";
                        e.target.style.transform = "scale(1.02)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#10b981";
                        e.target.style.transform = "scale(1)";
                      }}
                    >
                      <span style={{ fontSize: "20px" }}>+</span>
                      Add More Helpline
                    </button>
                  </div>

                  <div className="helpline-fields">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        height: "30px",
                        marginTop: "1.3rem",
                      }}
                    >
                      <input
                        type="checkbox"
                        id="removeAuctionDate"
                        checked={removeAuctionDate}
                        onChange={(e) => setRemoveAuctionDate(e.target.checked)}
                        style={{ margin: 0 }}
                      />
                      <label
                        htmlFor="removeAuctionDate"
                        style={{
                          margin: 0,
                          fontSize: "15px",
                          fontWeight: "500",
                          color: "#374151",
                          cursor: "pointer",
                        }}
                      >
                        Remove Auction Date
                      </label>
                    </div>
                  </div>

                  {/* Helpline text editor - UI only, value not sent; full width */}
                  <div className="helpline-editor-wrap" style={{ marginTop: "1.5rem", width: "100%", gridColumn: "1 / -1" }}>
                    <div className="quill-wrapper helpline-quill-full" style={{ width: "100%" }}>
                      <ReactQuill
                        value={helplineDescription}
                        onChange={setHelplineDescription}
                        modules={modules}
                        formats={formats}
                        placeholder="Information which you want to show on registration form"
                      />
                    </div>
                  </div>
                  <div className="form-submitting-row" style={{ marginTop: "-1rem", display: "flex", flexWrap: "nowrap", alignItems: "flex-end", gap: "1.5rem", gridColumn: "1 / -1", width: "100%" }}>
                    <div className="helpline-field form-submitting-text-wrap" style={{ flex: "1 1 auto", minWidth: "200px", maxWidth: "50%" }}>
                      <label htmlFor="formSubmittingText" style={{ marginBottom: "0.5rem" }}>Form submitting text</label>
                      <input
                        type="text"
                        placeholder="Form submitting text"
                        id="formSubmittingText"
                        className="helpline-input"
                        style={{ width: "100%" }}
                        value={formSubmittingText}
                        onChange={(e) => setFormSubmittingText(e.target.value)}
                      />
                    </div>  
                    <div className="helpline-field terms-checkbox-wrap" style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", gap: "10px", height: "60px", flex: "0 0 auto", whiteSpace: "nowrap" }}>
                      <input
                        type="checkbox"
                        id="termsAndConditions"
                        checked={termsAndConditions}
                        onChange={(e) => setTermsAndConditions(e.target.checked)}
                        style={{ margin: 0, width: "18px", height: "18px", cursor: "pointer", flexShrink: 0 }}
                      />
                      <label htmlFor="termsAndConditions" style={{ margin: 0, fontSize: "1.5rem", fontWeight: "600", color: "#1e293b", cursor: "pointer", whiteSpace: "nowrap" }}>
                        Add Terms & Conditions Link
                      </label>
                    </div>
                  </div>

                  {termsAndConditions && (
                    <div className="helpline-editor-wrap" style={{ marginTop: "1rem", width: "100%", gridColumn: "1 / -1" }}>
                      <p className="description-helper" style={{ marginBottom: "8px" }}>Terms & Conditions content (bold, colors, lists, etc.)</p>
                      <div className="quill-wrapper helpline-quill-full" style={{ width: "100%" }}>
                        <ReactQuill
                          value={termsAndConditionsContent}
                          onChange={setTermsAndConditionsContent}
                          modules={modules}
                          formats={formats}
                          placeholder="Enter Terms & Conditions here..."
                        />
                      </div>
                    </div>
                  )}
                </div>
              </HelplineContainer>
            </TabPanel>
            {/* <TabPanel>
              <Extra>
                <div className="helpline-fields">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      height: "30px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="removeAuctionDate"
                      checked={removeAuctionDate}
                      onChange={(e) => setRemoveAuctionDate(e.target.checked)}
                      style={{ margin: 0 }}
                    />
                    <label
                      htmlFor="removeAuctionDate"
                      style={{
                        margin: 0,
                        fontSize: "15px",
                        fontWeight: "500",
                        color: "#374151",
                        cursor: "pointer",
                      }}
                    >
                      Remove Auction Date
                    </label>
                  </div>
                </div>
              </Extra>
            </TabPanel> */}
          </StyledTabs>

          <div className="form-actions">
            <ActionButton className="primary" onClick={postfield}>
              Save All Changes
            </ActionButton>
          </div>
        </FormContainer>
      </PageContainer>

      {isoptpopup !== null && (
        <Modal onClose={() => setisoptpopup(null)}>
          <h3>Configure Dropdown Options</h3>
          <p className="modal-description">
            Enter options separated by commas (e.g., Option1,Option2,Option3)
          </p>
          <input
            type="text"
            value={optval}
            onChange={(e) => setoptval(e.target.value)}
            placeholder="Option1,Option2,Option3"
            className="options-input"
          />
          <div className="modal-actions">
            <ActionButton
              className="secondary"
              onClick={() => setisoptpopup(null)}
            >
              Cancel
            </ActionButton>
            <ActionButton
              className="primary"
              onClick={() => handleSaveOptions(isoptpopup)}
            >
              Save Options
            </ActionButton>
          </div>
        </Modal>
      )}
    </LoadingOverlay>
  );
}
export default JoinauctionCode;